// extracted by mini-css-extract-plugin
export var description = "contact-module--description--1-6jX";
export var infoWrapper = "contact-module--infoWrapper--3JlbS";
export var info = "contact-module--info--1PUr5";
export var icon = "contact-module--icon--1DR4u";
export var form = "contact-module--form--17aGy";
export var input = "contact-module--input--36un0";
export var button = "contact-module--button--2-vdE";